var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
export var Toggle = forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var checked = _a.checked, _e = _a.disabled, disabled = _e === void 0 ? false : _e, onChange = _a.onChange, className = _a.className, name = _a.name, id = _a.id, props = __rest(_a, ["checked", "disabled", "onChange", "className", "name", "id"]);
    var handleToggle = useCallback(function () {
        if (!disabled) {
            onChange(!checked);
        }
    }, [disabled, checked, onChange]);
    // For accessibility compliance
    var handleKeyDown = useCallback(function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && !disabled) {
            event.preventDefault();
            handleToggle();
        }
    }, [disabled, handleToggle]);
    return (_jsxs("div", { className: classNames(styles['toggle-root'], (_b = {}, _b[styles.disabled] = disabled, _b), className), tabIndex: disabled ? -1 : 0, onKeyDown: handleKeyDown, onClick: handleToggle, role: "switch", "aria-checked": checked, children: [_jsx("input", __assign({ ref: ref, type: "checkbox", className: styles['toggle-input'], checked: checked, disabled: disabled, name: name, id: id, "aria-hidden": "true", tabIndex: -1 }, props)), _jsx("div", { className: classNames(styles['toggle-track'], (_c = {},
                    _c[styles.checked] = checked,
                    _c[styles.disabled] = disabled,
                    _c)), children: _jsx("div", { className: classNames(styles['toggle-thumb'], (_d = {},
                        _d[styles.checked] = checked,
                        _d[styles.disabled] = disabled,
                        _d)) }) })] }));
});
Toggle.displayName = 'Toggle';
